/**
 * Dynamically wait for an event to be triggered.
 * 
 * If the event has already been triggered, return true.
 * 
 * @param { boolean } eventResolved - Has the event already been triggered?
 * @param { string } eventName - Name of event to listen for.
 * @returns { Promise<boolean> }
 */
export const waitForEvent = (eventResolved, eventName) => {
    return new Promise(resolve => {
        if (eventResolved) {
            resolve(eventResolved);
        } else {
            window.addEventListener(
                eventName,
                data => {
                    resolve(data);
                },
                { once: true }
            );
        }
    });
};

/**
 * Checks for WIAPILoaded event.
 * 
 * This check ensures that releavant WIAPI data is set in `local/sessionStorage`
 * 
 * @returns { Promise<boolean> }
 */
export const isWIAPILoaded = async () => {
    return waitForEvent(
        window.DDC?.PrivateAPI?.integrationsLoaded,
        'WIAPILoaded'
    );
};